import { useState, useEffect } from "react";
import { useAuth } from "../../auth/AuthContext";
import { useNavigate } from "react-router-dom";
import Button from "../../components/button/Button";
import RecuperarSenhaModal from "../../components/recuperarSenha/RecuperarSenhaModal";

function Login() {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [loading, setLoading] = useState(false); // 👈 ADICIONE ESTA LINHA
  const [isModalOpen, setIsModalOpen] = useState(false); // 👈 Estado do modal

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); // Ativa o loading

    // 💡 Sanitiza o e-mail para minúsculas (preservando a senha)
    const emailSanitizado = email.trim().toLowerCase();

    try {
      await login(emailSanitizado, senha); // 👈 chama o context

      navigate("/");

    } catch (error) {
      alert(error.response?.data?.erro || "Erro ao fazer login");
    } finally {
      setLoading(false); // Desativa o loading
    }
  };

  return (
    <div className="container-login">
      <div className="card card-login">

        <img 
          src="logo_aplicacao.png"
          alt="Logo do escritório"
          style={{ width: "110px", height: "90.5px" }}
        />

        <form onSubmit={handleLogin}>

          <div className="form-group">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <input
              type="password"
              placeholder="Senha"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
            />
          </div>

          <Button type="submit" loading={loading}>
            Entrar
          </Button>

          {/* 🟢 Botão para abrir o modal de recuperação */}
          <button
            type="button"
            className="btn login-button-register"
            onClick={() => setIsModalOpen(true)}
            style={{ marginTop: "8px" }}
          >
            Esqueceu sua senha?
          </button>

        </form>
      </div>
      {/* 🟢 Renderização do Modal */}
      <RecuperarSenhaModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
}

export default Login;